import { useQuery } from "@tanstack/react-query";
import { getInvestmentNotes } from "./portfolioApis";

export const PortfolioQueryKeys = {
    GET_INVESTMENT_NOTES: 'getInvestmentNotes',
}

export const useInvestmentNotesQuery = (page = 1, params = {}, allocatedCompleted) => {
    return useQuery({
        queryKey: [PortfolioQueryKeys.GET_INVESTMENT_NOTES, page, params, allocatedCompleted],
        queryFn: async () => {
            const response = await getInvestmentNotes(page, params, allocatedCompleted);
            return response.data;
        },
        staleTime: 5 * 60 * 1000,
        cacheTime: 10 * 60 * 1000,
        keepPreviousData: true,
    });
};